module.exports = __webpack_public_path__ + "files/921d0496a6f9b9d9d461b98d157191d5.svg";